import React, { useState, useEffect, useRef } from "react";
import { Col, Row } from "react-bootstrap";
import {
  ActionButtons,
  ContentFilters,
  ContentLoader,
  ContentTable,
  Convention,
  TableViewButton,
  useStyles,
} from "./AdminCoachesComponent.styled";
import Card from "../../components/ConfigurationCards";
import GeneralFiltersContainer from "../../containers/GeneralFiltersContainer/GeneralFiltersContainer";
import Tooltip from "@material-ui/core/Tooltip";
import ViewList from "@material-ui/icons/ViewList";
import ViewCards from "@material-ui/icons/ViewModule";
import ModalLoader from "../ModalLoader/ModalLoader";
import MaterialTable from "material-table";
import PointersLine from "../Loaders/PointersLine/PointersLine";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { IconButton } from "@material-ui/core";
import ViewControlMenu from "../ViewControlMenu/ViewControlMenu";
import TablePagination from "@material-ui/core/TablePagination";
import { AntSwitch } from "../../helpers/antSwitch";
import SearchComponent from "../SearchComponent/SearchComponent";
import { theme as themeConfig } from "../../themes/themes";
import { DeleteTwoTone, EditTwoTone } from "@material-ui/icons";

const AdminCoachesComponent = ({
  goToCreateCoach,
  filtersViews,
  FilterEvents,
  setDataFilter,
  filtered,
  setFiltered,
  showCards,
  setShowCards,
  loadingGetCoaches,
  showLoader,
  toggleChecked,
  handleClickActions,
  anchorSelected,
  anchorEl,
  setAnchorEl,
  setAnchorSelected,
  handleEditEvent,
  handleCloseActions,
  setOpenDeleteModal,
  coachesList,
  dataPaginated,
  currentPage,
  setCurrentPage,
  rowsPerPage,
  rowsPerPageList,
  setRowsPerPage,
}) => {
  const classes = useStyles();
  const [searchText, setSearchText] = useState();
  const rSearch = useRef();

  const getDataBySearch = () => {
    setSearchText(rSearch?.current?.value);
  };

  const applySearchOnBreak = () => {
    let timer;
    return function () {
      clearTimeout(timer);
      timer = setTimeout(() => {
        getDataBySearch();
      }, 500);
    };
  };

  const handleSearch = applySearchOnBreak();

  const tablePaginationListView = (props) => {
    const computedProps = { ...props };
    computedProps.style = {
      ...(computedProps?.style ?? {}),
      borderBottom: "0px",
    };
    return (
      <>
        <div style={{ display: "flex", marginTop: "1rem" }}>
          <div
            style={{
              display: "flex",
              width: "95%",
              justifyContent: "flex-start",
              alignItems: "center",
            }}
          >
            <Convention>
              <div
                style={{
                  background: "rgba(191, 191, 191, 1)",
                  height: "1em",
                  width: "1em",
                  borderRadius: "7px",
                }}
              ></div>
              <p>Disable</p>
              <div
                style={{
                  background: "rgba(4, 180, 105, 1)",
                  height: "1em",
                  width: "1em",
                  borderRadius: "7px",
                }}
              ></div>
              <p>Active</p>
            </Convention>
          </div>
          <div
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "flex-end",
              alignItems: "center",
            }}
          >
            <table>
              <tbody>
                <tr>
                  <TablePagination {...computedProps} />
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </>
    );
  };

  useEffect(() => {
    FilterEvents(searchText);
  }, [searchText]);

  return (
    <>
      <ActionButtons
        style={{
          marginLeft: "1rem",
          marginTop: "18px",
          position: "relative",
          zIndex: "2",
        }}
      >
        <Col>
          <Card
            colorBorder="#FFFFFF"
            coloricon="#FFFFFF"
            code="new-event"
            title="Create Coach"
            icon="plus"
            subtitle="Create Event"
            footerText="New event"
            setFormTrigger={() => goToCreateCoach()}
          />
        </Col>
        <Col>
          <ContentFilters>
            <GeneralFiltersContainer
              filtersViews={filtersViews}
              FilterEvents={FilterEvents}
              setDataFilter={setDataFilter}
              filtered={filtered}
              setFiltered={setFiltered}
            ></GeneralFiltersContainer>
            <SearchComponent
              handleSearch={handleSearch}
              rSearch={rSearch}
              setSearchText={setSearchText}
            />
          </ContentFilters>
        </Col>
        <Col>
          <div className="right-section">
            <div className="table-action">
              <Tooltip title="View List">
                <TableViewButton
                  iconColor={showCards}
                  onClick={() => setShowCards(false)}
                  className="MuiButtonBase-root MuiIconButton-root"
                >
                  <span
                    style={{ width: "fit-content" }}
                    className="MuiIconButton-label"
                  >
                    <ViewList className="list-view" />
                  </span>
                </TableViewButton>
              </Tooltip>
              <Tooltip title="View Cards">
                <TableViewButton
                  iconColor={showCards}
                  onClick={() => setShowCards(true)}
                  style={{ borderLeft: "none" }}
                  className="MuiButtonBase-root MuiIconButton-root"
                >
                  <span
                    style={{ width: "fit-content" }}
                    className="MuiIconButton-label"
                  >
                    <ViewCards className="card-view" />
                  </span>
                </TableViewButton>
              </Tooltip>
            </div>
          </div>
        </Col>
      </ActionButtons>
      <Row>
        <Col md={12}>
          {loadingGetCoaches || (showLoader && <ModalLoader></ModalLoader>)}

          <ContentTable>
            {loadingGetCoaches ? (
              <ContentLoader>
                <PointersLine color={themeConfig.text.primary} />
              </ContentLoader>
            ) : null}
            {!loadingGetCoaches && !showCards && (
              <MaterialTable
                title=""
                columns={[
                  {
                    title: "First Name",
                    field: "cFirstName",
                    type: "string",
                  },
                  {
                    title: "Last Name",
                    field: "cLastName",
                    type: "string",
                    headerStyle: {
                      padding: "0px 16px",
                    },
                  },
                  {
                    title: "Country",
                    field: "cCountryName",
                    type: "string",
                    headerStyle: {
                      padding: "0px 16px",
                    },
                  },
                  {
                    title: "City",
                    field: "cCityName",
                    type: "string",
                    headerStyle: {
                      padding: "0px 16px",
                    },
                  },
                  {
                    title: "Agents assigned",
                    field: "agentsAssigned",
                    type: "string",
                    headerStyle: {
                      padding: "0px 16px",
                    },
                  },
                  {
                    title: "Disable",
                    field: "coachState",
                    type: "string",
                    sorting: false,
                    cellStyle: {
                      padding: "0px 31px",
                    },
                    render: (rowData) => {
                      if (rowData?.idCoach) {
                        return (
                          <FormControlLabel
                            control={
                              <AntSwitch
                                size="small"
                                checked={
                                  rowData?.coachState.toUpperCase() === "ACTIVE"
                                    ? true
                                    : false
                                }
                                onChange={() => toggleChecked(rowData)}
                              />
                            }
                          />
                        );
                      }
                    },
                  },
                  {
                    title: "Actions",
                    field: "internal_action",
                    sorting: false,
                    cellStyle: {
                      padding: "0px 6px",
                    },
                    headerStyle: {
                      padding: "0px",
                    },
                    render: (rowData) =>
                      rowData && (
                        <div
                          style={{ display: "flex", justifyContent: "center" }}
                        >
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <Tooltip title="Edit">
                              <IconButton
                                className={classes.active}
                                onClick={() => {
                                  setAnchorEl(null);
                                  setAnchorSelected(null);
                                  handleEditEvent(rowData);
                                }}
                              >
                                <EditTwoTone />
                              </IconButton>
                            </Tooltip>
                          </div>
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <Tooltip title="Delete">
                              <IconButton
                                className={classes.active}
                                disabled={rowData?.coachState === "Active"}
                                onClick={() => {
                                  setAnchorEl(null);
                                  setAnchorSelected(null);
                                  setOpenDeleteModal(rowData);
                                }}
                              >
                                <DeleteTwoTone />
                              </IconButton>
                            </Tooltip>
                          </div>
                        </div>
                      ),
                  },
                ]}
                data={coachesList}
                options={{
                  maxBodyHeight: 450,
                  search: false,
                  toolbar: false,
                  showTitle: false,
                  cellStyle: {
                    padding: "5px 10px",
                  },
                  headerStyle: {
                    zIndex: 1,
                    fontWeight: "bold",
                  },
                }}
                components={{
                  Pagination: tablePaginationListView,
                }}
              ></MaterialTable>
            )}
            {showCards && (
              <>
                <ViewControlMenu
                  className="mt-5"
                  identity={"coaches-list"}
                  title={""}
                  showCards={showCards}
                  setShowCards={setShowCards}
                  list={dataPaginated}
                  isAgent={false}
                  toggleChecked={toggleChecked}
                  handleClickActions={handleClickActions}
                  anchorSelected={anchorSelected}
                  anchorEl={anchorEl}
                  handleCloseActions={handleCloseActions}
                  handleEditEvent={handleEditEvent}
                  setAnchorEl={setAnchorEl}
                  setAnchorSelected={setAnchorSelected}
                  setOpenDeleteModal={setOpenDeleteModal}
                />
                <div style={{ display: "flex", padding: "1rem" }}>
                  <Convention>
                    <div
                      style={{
                        background: "rgba(191, 191, 191, 1)",
                        height: "1em",
                        width: "1em",
                        borderRadius: "7px",
                      }}
                    ></div>
                    <p>Disable</p>
                    <div
                      style={{
                        background: "rgba(4, 180, 105, 1)",
                        height: "1em",
                        width: "1em",
                        borderRadius: "7px",
                      }}
                    ></div>
                    <p>Active</p>
                  </Convention>
                  {coachesList.length > 0 ? (
                    <TablePagination
                      component="div"
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        width: "100%",
                      }}
                      count={coachesList.length}
                      page={currentPage}
                      onPageChange={(e, newPage) => {
                        setCurrentPage(newPage);
                      }}
                      rowsPerPage={rowsPerPage}
                      rowsPerPageOptions={rowsPerPageList}
                      onRowsPerPageChange={(event) => {
                        setRowsPerPage(
                          parseInt(
                            event?.target?.value ? event?.target?.value : "5"
                          )
                        );
                        setCurrentPage(0);
                      }}
                    />
                  ) : (
                    <></>
                  )}
                </div>
              </>
            )}
          </ContentTable>
        </Col>
      </Row>
    </>
  );
};

export default AdminCoachesComponent;
